import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { getInvoices } from "../../redux/actions/getInvoiceAction";
import Util from "../../validation";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { getInvoicesCofig } from "../../redux/actions/getInvoiceConfigAction";
import Autocomplete from "@mui/lab/Autocomplete";
import {
	resetGetCustomerIdAndNameList,
	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import {
	resetInvoiceRegeneration,
	invoiceRegeneration
} from "../../redux/actions/invoiceRegenerationAction";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const MerchantInvoice = () => {
	// var res = {};
	// res = {
	//   status: "success",
	//   responseCode: "10001",
	//   invoiceMasterDetailsVOList: [
	//     {
	//       date: "12/07/19",
	//       invoiceNo: "9180",
	//       memberID: "11898",
	//       orderId: "AB_1189810334",
	//       orderDescription: "Duplicate order for AB_1189810332",
	//       amount: "12.00",
	//       status: "regenerated",
	//       action: "Regenerated",
	//     },
	//     {
	//       date: "14/08/19",
	//       invoiceNo: "9181",
	//       memberID: "11899",
	//       orderId: "AB_1189810335",
	//       orderDescription: "Duplicate order for AB_1189810335",
	//       amount: "12.00",
	//       status: "regenerated",
	//       action: "Regenerated",
	//     },
	//   ],
	// };

	const dispatch = useDispatch();

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [invoiceStatus, setInvoiceStatus] = useState(false);
	const [invoiceResArray, setInvoiceResArray] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const classes = useStyles();
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const handleDateChange = (date) => {
		if (date > selectedToDate) {
			setSelectedToDate(date);
		}
		setSelectedDate(date);
	};
	const navigate = useHistory();

	useEffect(() => {
		dispatch(resetInvoiceRegeneration());
	}, []);

	const getInvoiceRes = useSelector(({ getInvoice }) => getInvoice);
	const getInvoiceConfigRes = useSelector(
		({ getInvoiceConfig }) => getInvoiceConfig
	);

	const [memberId, setMemberId] = useState("");
	const handleChange = ({ target: { name, value } }) => {


		if (name === "memberId") {
			// console.log("memberId", memberId)
			setMemberId(value)
		}
	}

	const [user, setUser] = useState({
		// memberId: "",
		invoiceId: "",
		merchantOrderDescription: "",
		merchantOrderId: "",
		merchantTransactionId: "",
		status: ""
	});

	const {
		// memberId,
		invoiceId,
		merchantOrderDescription,
		merchantOrderId,
		merchantTransactionId,
		status
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const getInvoiceReq = () => {
		setInvoiceStatus(true);
		setIsLoading(true);
		const req = {
			authentication: {
				partnerId: regenerateTokenRes.data.partnerId || "",
				memberId: memberId.split("-")[0] || ""
				// memberId:memberId
			},
			pagination: {
				pageno: "",
				records: "",
				fromdate: moment(selectedDate).format("DD/MM/YYYY"),
				todate: moment(selectedToDate).format("DD/MM/YYYY")
			},
			invoiceId: invoiceId,
			merchantOrderDescription: merchantOrderDescription,
			merchantOrderId: merchantOrderId,
			merchantTransactionId: merchantTransactionId,
			status: status === "ALL" ? "" : status,
		};

		return dispatch(getInvoices(req, authToken));
	};

	// useEffect(() => {
	//   getInvoiceReq();
	// }, [])
	const getInvoiceFunc = () => {
		if (invoiceStatus) {
			if (getInvoiceRes.success == true) {
				if (getInvoiceRes.data.statusInvoiceResult.description == "No record found") {
					setInvoiceStatus(false);
					setIsLoading(false);
					NotificationPopups(
						"error",
						"Failed",
						getInvoiceRes.data.statusInvoiceResult.description
					);
				} else {
					setInvoiceResArray([].concat(getInvoiceRes.data.invoiceList));
					setIsLoading(false);
				}
			}
		}
	};

	useEffect(() => {
		getInvoiceFunc();
	}, [getInvoiceRes.success]);

	useEffect(() => {
		if (getInvoiceRes.success == true) {
			setPage(0);
		}
	}, [getInvoiceRes.success]);

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const sendInvoiceId = (id, name) => {
		navigate.push({
			pathname: `/index/getInvoiceDetails`,
			search: `?userId=${id}`
		});
	};

	const sendAction = (id) => {
		navigate.push({
			pathname: `/index/getActionDetails`,
			search: `?userId=${id}`
		});
	};
	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const filterOptions = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<FormControl fullWidth>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								</LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<FormControl fullWidth>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
										minDate={selectedDate}
									/>
								</LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								style={{ margin: "0rem" }}
								select
								autoFocus
								variant="standard"
								margin="dense"
								id="name"
								label="Status"
								type="name"
								fullWidth
								name="status"
								defaultValue={"ALL" || status}
								onChange={onInputChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="ALL" selected="ALL">
									All
								</MenuItem>
								<MenuItem value="cancelled">CANCELLED</MenuItem>
								<MenuItem value="expired">EXPIRED</MenuItem>
								<MenuItem value="mailsent">MAIL SENT</MenuItem>
								<MenuItem value="processed">PROCESSED</MenuItem>
								<MenuItem value="regenerated">RE-GENERATED</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								variant="standard"

								label="Tracking Id"
								type="tel"
								fullWidth
								value={merchantTransactionId}
								name="merchantTransactionId"
								onChange={onInputChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Invoice Number"
								type="tel"
								fullWidth
								variant="standard"

								value={invoiceId}
								name="invoiceId"
								onChange={onInputChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								variant="standard"

								label="Order Id"
								type="tel"
								fullWidth
								value={merchantOrderId}
								name="merchantOrderId"
								onChange={onInputChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								variant="standard"

								label="Order Description"
								type="tel"
								fullWidth
								value={merchantOrderDescription}
								name="merchantOrderDescription"
								onChange={onInputChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
						</Grid>

						{/* <Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								// required
								margin="dense"
								id="name"
								variant="standard"

								label="Member Id"
								type="tel"
								fullWidth
								value={memberId}
								name="memberId"
								onChange={onInputChange}
							/>
						</Grid> */}

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptions}
								value={memberId}
								onChange={handleChange}
								onInputChange={(event, newInputValue) => {
									setMemberId(newInputValue);
								}}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Member ID"
										style={{ marginTop: "8px" }}
										// required
										type="tel"
										fullWidth
										{...params}
										// value={merchantID}
										name="memberId"
										// onChange={(e) => onInputChange(e, "number")}

										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
									/>
								)}
							/>
						</Grid>

						<Grid
							item
							xs={12}
							sm={12}
							md={4}
							lg={4}
							style={{
								textAlign: "center",
								marginTop: "10px"
							}}
						>
							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                  textAlign: "center",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getInvoiceReq}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getInvoiceReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				<div>
					{isLoading ? (
						<LoadingSpinner />
					) : invoiceResArray.length == undefined || !invoiceStatus ? (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Invoice Details
									</Typography>
								</Grid>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Alert
										className="my-3 tableHeaderColor"
										variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
									>
										No Records Found!
									</Alert>
								</Grid>
							</Grid>
						</Card>
					) : (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Invoice Details
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="my-3">
									<Table className={classes.table} aria-label="a dense table">
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Date{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Invoice Number
												</TableCell>
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Member Id
												</TableCell>
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Order Id
												</TableCell>
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Order Description
												</TableCell>
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Amount{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Status
												</TableCell>
												<TableCell
													align="center"
													style={{
														fontSize: "15px",
														fontWeight: "bold",
														color: "white"
													}}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{invoiceResArray &&
												[]
													.concat(invoiceResArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.createdDate}
															</TableCell>
															<TableCell
																align="center"
																className="themeText"
																style={{
																	marginTop: "1rem",
																	// color: "#00b9f5",
																	cursor: "pointer",
																	fontWeight: "600"
																}}
																onClick={() =>
																	sendInvoiceId(
																		row.systemInvoiceId,
																		row.memberId
																	)
																}
															>
																{row.systemInvoiceId}
															</TableCell>
															<TableCell align="center">
																{row.memberId}
															</TableCell>
															<TableCell align="center">
																{row.orderId}
															</TableCell>
															<TableCell align="center">
																{row.orderDescription}
															</TableCell>
															<TableCell align="center">{row.amount}</TableCell>
															<TableCell align="center">
																{row.invoiceStatus}
															</TableCell>
															<TableCell align="center">
																{row.invoiceStatus == "generated" ? (
																	<span
																		className="themeText"
																		style={{
																			marginTop: "1rem",
																			// color: "rgb(182 182 182)",
																			fontWeight: "600"
																		}}
																	// onClick={() => sendAction(row.memberId)}
																	>
																		Regenerate
																	</span>
																) : row.invoiceStatus == "mailsent" ? (
																	<span
																		className="themeText"
																		style={{
																			marginTop: "1rem",
																			// color: "rgb(182 182 182)",
																			fontWeight: "600"
																		}}
																	// onClick={() => sendAction(row.memberId)}
																	>
																		Regenerate
																	</span>
																) : row.invoiceStatus == "regenerated" ? (
																	<span
																		className="themeText"
																		style={{
																			marginTop: "1rem",
																			// color: "rgb(182 182 182)",
																			fontWeight: "600"
																		}}
																	// onClick={() => sendAction(row.memberId)}
																	>
																		Regenerate
																	</span>
																) : (
																	<span
																		className="themeText"
																		style={{
																			marginTop: "1rem",
																			// color: "#00b9f5",
																			cursor: "pointer",
																			fontWeight: "600"
																		}}
																		onClick={() => sendAction(row.memberId)}
																	>
																		Regenerate
																	</span>
																)}
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={invoiceResArray.length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					)}
				</div>
			</Layout>
		</>
	);
};

export default MerchantInvoice;
